import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { HeroHeader } from 'app/delivery-area/components/hero-header'
import { Section } from 'system-ui/section'
import { DownloadApp } from 'app/delivery-area/components/download-app'
import openNotifyMeOldModal from 'notify-me'

import workerImage from 'assets/img/worker.jpeg'
import notifyMeImage from 'assets/img/notify-me.jpeg'

const Home = () => {
  const { t } = useTranslation()
  return (
    <Fragment>
      <HeroHeader />
      <Section imageURL={workerImage} imageAlt={t('cities_image')}>
        <h3 className="section__title">{t('cities_title')}</h3>
        <p className="section__description">{t('cities_description')}</p>
      </Section>
      <Section
        inverted
        imageURL={notifyMeImage}
        imageAlt={t('notify_me_image')}
      >
        <h3 className="section__title">{t('notify_me_title')}</h3>
        <p id="notify-me-description" className="section__description">
          {t('notify_me_description')}
        </p>
        <button
          className="section__link"
          aria-describedby="notify-me-description"
          onClick={openNotifyMeOldModal}
        >
          {t('notify_me_link')}
        </button>
      </Section>
      <DownloadApp />
    </Fragment>
  )
}

export { Home }
